import AvatarText from "@/components/reusables/AvatarText";
import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Sheet, SheetContent, SheetHeader } from "@/components/ui/sheet";
import { ToolsConstants } from "@/constants/tools.constant";
import { ExtendedColumnDef } from "@/interfaces/globals";
import {
  IProductRequest,
  IProductRequestDetail,
} from "@/interfaces/tools.interface";
import { InvoiceDetailCard } from "@/pages/support/ticket-board-page/_components/board/TaskSheet";

interface ProductRequestSheetProps {
  isOpen: boolean;
  toggleProductRequestSheet: () => void;
  data: IProductRequest;
}

const ProductRequestSheet = ({
  isOpen,
  toggleProductRequestSheet,
  data,
}: ProductRequestSheetProps): JSX.Element => {
  const columns: ExtendedColumnDef<IProductRequestDetail>[] = [
    {
      map: {
        key: "Name",
      },
      accessorKey: "Name",
      header: "Name",
      cell: ({ row }): JSX.Element => {
        return (
          <AvatarText
            src={row?.original?.product?.images?.[0]}
            name={`${row.original.product?.name}`}
            title={`${row.original.product?.name}`}
          />
        );
      },
      meta: {
        showRightBorder: true,
      },
    },
    {
      map: {
        key: "Quantity",
      },
      accessorKey: "Quantity",
      header: "Quantity",
      cell: ({ row }) => row.original?.quantity ?? "-",
    },
  ];

  return (
    <Sheet open={isOpen} onOpenChange={toggleProductRequestSheet}>
      <SheetContent className='sm:max-w-[400px] lg:max-w-[800px] space-y-3 '>
        <SheetHeader>
          <h1 className='text-2xl font-bold '>
            {ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT}
          </h1>
        </SheetHeader>
        <ScrollArea className=' max-h-[90vh] overflow-y-scroll scrollbar-none'>
          <InvoiceDetailCard
            value={data?.project?.name ?? "N/A"}
            header='Project'
          />
          <InvoiceDetailCard value={data?.remarks ?? "-"} header='Remarks' />
          <section className='mt-3'>
            <CustomTable
              data={data?.items ?? []}
              columns={columns}
              title={ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT}
              empty={{}}
              hide={{
                filters: true,
                functions: true,
              }}
            />
          </section>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export default ProductRequestSheet;
